import _mapKeys from 'lodash.mapkeys';
import { FETCH_LISTS } from '../actions/actions_lists';
// import { FETCH_LIST } from '../actions/actions_lists';

export default function(state = {}, action) {

    if (action.error) {
        return { ...state, 'error': true}
    }

    switch(action.type) {
        case FETCH_LISTS:
            return _mapKeys(action.payload.data, 'list_id');
        // case FETCH_LIST:
        //     console.log('FETCH_LIST');
        //     return { ...state, [action.payload.data['list_id']]: action.payload.data }
        default:
            return state;
    }   
}


// WEBPACK FOOTER //
// ./src/reducers/reducer_lists.js